// extracted by mini-css-extract-plugin
export default {"delete":"DeleteOlink_delete__UiaJt","container":"DeleteOlink_container__jA73D","delete__warning":"DeleteOlink_delete__warning__mKJaf"};